import { command } from "../../app/command";
import { query } from "../../app/query";
import { EventPayload } from "../../common/types/Event";
import { Options } from "../../common/types/requestOptions";
import {
  HrTaskAck,
  HrTaskAcknowledged,
  HrTasklistkRows,
  HrTasklistQuery,
} from "./tasklist/types";
import { DashboardTalentCounts } from "./talents/types";

export const hrTaskListQuery = (
  filters: HrTasklistQuery,
  options: Options = {},
): Promise<HrTasklistkRows> =>
  query<HrTasklistQuery, HrTasklistkRows>(
    "/projections/qry/hrTaskList",
    filters,
    options,
  );

export const hrTaskAck = async (
  body: HrTaskAck,
  options: Options = {},
): Promise<EventPayload<HrTaskAcknowledged>[]> =>
  command<HrTaskAck, HrTaskAcknowledged>(
    "/matching/cmd/ackHrTask",
    body,
    options,
  );

export const talentsDashboardCountsQuery = (
  filters: {},
  options: Options = {},
): Promise<DashboardTalentCounts> =>
  query<{}, DashboardTalentCounts>(
    "/projections/qry/talentsDashboardCounts",
    filters,
    options,
  );
